/** `null` reads as unknown rather than as no time at all - see `SongQueue.getTotalDuration`. */
export const formatQueueDuration = (seconds: number | null) => {
  if (seconds === null) return 'unknown length';
  if (seconds < 60) return 'under a minute';

  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `${minutes} min`;

  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;

  return rest === 0 ? `${hours} h` : `${hours} h ${rest} min`;
};
